import React from 'react';
import styles from './index.module.less';
import TopInfo from '@pro/activity/testerClub/Products/TopInfo';
import { IUseEarlyAccess } from '@pro/activity/testerClub/useEarlyAccess';
import { IListItem } from '@pro/activity/testerClub/interface';
import cn from 'classnames';
import ProductImages from '@pro/activity/testerClub/Products/ProductImages'
import ProductTags from '@pro/activity/testerClub/Products/ProductTags'
import OptionsButton from '@pro/activity/testerClub/Products/OptionsButton'
import ProductStatus from '@pro/activity/testerClub/Products/ProductStatus'


type IProps = {
    earlyAccess: IUseEarlyAccess;
    product: IListItem;
}


const ProductPc: React.FC<IProps> = (props) => {

    const { earlyAccess, product } = props
    const { tabActivityKey } = earlyAccess

    return(
        <div className={cn(styles['product-wrap'], 'flex ')}>

            <div className={styles['left-box']}>
                <ProductImages className={styles['swiper-images']}  product={product}/>

            </div>

            <div className={cn(styles['right-box'], 'flex flex-vertical flex-justify')}>
                <div>
                    <TopInfo className={styles['top-info']} product={product}/>

                    {tabActivityKey === 'completed' && (
                        <ProductStatus />
                    )}

                    <p className={styles['product-title']}>
                        {product.title}
                    </p>

                    <ProductTags className={styles.tags} product={product}/>
                </div>

                <div>
                    <OptionsButton
                        earlyAccess={earlyAccess}
                        product={product}
                    />
                </div>

            </div>

        </div>
    );
};

export default ProductPc